import type { OrderProductOptions } from "../OrderProductOptions.js";
import { ProductOption } from "../ProductOption.js";
import { createEmptyOptions } from "./createEmptyOptions.js";

export function hasOptions(options: OrderProductOptions | undefined): options is OrderProductOptions {
	if (!options) {
		return false;
	}

	const emptyOptions = createEmptyOptions(options.size);
	const isEmpty: Record<ProductOption, boolean> = {
		[ProductOption.Numbers]: options.numbers.length === emptyOptions.numbers.length,
		[ProductOption.ExtraFruit]: options.extraFruit === emptyOptions.extraFruit,
		[ProductOption.GlutenFreeVariant]: options.glutenFree === emptyOptions.glutenFree,
		[ProductOption.LactoseFreeVariant]: options.lactoseFree === emptyOptions.lactoseFree,
		[ProductOption.Meringues]: options.meringues === emptyOptions.meringues,
		[ProductOption.CreamColor]: options.creamColor === emptyOptions.creamColor,
		[ProductOption.Labels]: options.labels.length === emptyOptions.labels.length,
		[ProductOption.LyingPhoto]: options.lyingPhoto === emptyOptions.lyingPhoto,
		[ProductOption.StandingPhotos]: options.standingPhotos.length === emptyOptions.standingPhotos.length,
		[ProductOption.Macaroons]: options.macaroons === emptyOptions.macaroons,
		[ProductOption.Figurines]: options.figurines.length === emptyOptions.figurines.length,
	};
	return !Object.values(isEmpty).every(Boolean);
}
